export const BUILDER_API_KEY = String(process.env.NEXT_PUBLIC_BUILDER_API_KEY);
export const BUILDER_PREVIEW_SECRET = 'lUiX3802YddIR14FhcCe5cAtP6Bf0cTYOs9csLsbn7EH0eosKYkmK7VHLq8T';
export const NOREPLY_EMAIL = String(process.env.NEXT_PUBLIC_NOREPLY_EMAIL);
export const GTM_ID: string = String(process.env.NEXT_PUBLIC_GTM_ID) ?? '';
